import { Component, OnInit } from '@angular/core';
import { UntypedFormGroup, UntypedFormBuilder, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { Router, ActivatedRoute } from '@angular/router';
import { FormValidationsService, QuoteDataCaptureService, ProductCodeValidators } from 'src/app/shared';
import { Store } from '@ngrx/store';
import { Observable } from 'rxjs';
import { AppState } from '../../../../store/state/app.state';
import * as ReqQuoteCalcActions from '../../../../store/actions/request-quote-calculation.actions';
import * as ResQuoteCalcActions from '../../../../store/actions/response-quote-calculation.actions';
import { YourPension } from '../../../../model/ngrx/your-pension.model';

import * as UserDataConfig from '../../config/user-data.config';
import { STORE_VAL } from 'src/app/shared/constants/store-val.constant';

@Component({
  selector: 'app-your-options-questions',
  templateUrl: './your-options-questions.component.html',
  styleUrls: ['./your-options-questions.component.scss']
})
export class YourOptionsQuestionsComponent implements OnInit {

  public contentData;
  public userInputDetail = UserDataConfig.ElementsConfig;
  public userForm: UntypedFormGroup;
  yourPensionStore: Observable<YourPension[]>;
  yourPensionData: YourPension;
  constructor(private fb: UntypedFormBuilder, private activatedRoute: ActivatedRoute, private router: Router,
    private quoteDataCaptureService: QuoteDataCaptureService, private store: Store<AppState>) {
    this.contentData = this.activatedRoute.snapshot.data.contentData.youroptionsquestions;
    this.yourPensionStore = store.select(STORE_VAL.your_pension);
    this.yourPensionStore.subscribe(res => {
      if (res.length > 0) {
        this.yourPensionData = res[0];
      }
    });
  }

  ngOnInit() {
    this.userFormData();
    this.updateHeader();
  }

  userFormData = () => {
    this.userInputDetail.buttonConfig.label = 'Calculate';
    this.userForm = this.fb.group({
      next: ['']
    });
  }
  gotoNextPage = () => {
    const pensionAmount = this.yourPensionData.totalSum;
    const val = (pensionAmount * 7) / 100;
    this.store.dispatch(new ResQuoteCalcActions.RemoveQuoteCalculation(0));
    this.store.dispatch(new ReqQuoteCalcActions.RemoveReqQuoteCalculation(0));
    // tslint:disable-next-line: max-line-length
    this.store.dispatch(new ReqQuoteCalcActions.AddReqQuoteCalculation(
      {
        advance: 'A',
        frequency: 'Y',
        incomepercentage: 67,
        increasedincome: '',
        increasedincomeslider: 2,
        periodofincome: 8,
        taxfreelumpsum: 7,
        valueprotection: 'Y',
        calculatedTaxFreeLumSum: val
      }
    ));
    this.quoteDataCaptureService.postQuickQuoteValues(true, 1).subscribe(res => {
      this.router.navigate(['/quote/your-product-options']);
    });
  }
  updateHeader = () => {
    if (this.contentData) {
      const headerType = '<strong>Pension Annuity</strong>';
      this.contentData.header = this.contentData.header.replace('{}', headerType);
    }
  }

}
